<template lang="pug">
  article.banner.loading.row.middle.center(v-if='loading')
    loader(size="inner")
  section(v-else)
    article.banner.relative.row
      img.image.absolute(:src="ephemerideInfo.feedThumbnail" :alt='ephemerideInfo.title')
      .shadow.absolute
      .date.absolute
        span.text-small.date-text.bold.white {{ formatedDate }}
      h4.text-normal.uppercase.white.bold.title.m-top-auto.m-left-2.m-bottom-2 {{ ephemerideInfo.title }}
    section.info.column.center.m-top-2
      h2.title-medium.bold.blue.m-bottom-1 {{ ephemerideInfo.title }}
      p.text-normal.dark-gray.md-content.small(v-html='ephemerideInfo.description')
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import Loader from '../../Loader'

export default {
  props: {
    loading: { type: Boolean }
  },
  components: { Loader },
  computed: {
    ...mapState({
      locale: state => state.behavior.locale,
      ephemerideInfo: state => state.newFeed.searchResults.ephemeride.data
    }),
    formatedDate() {
      return moment()
        .locale(this.ephemerideInfo.startDate)
        .format('MMM DD')
        .replace('.', '')
        .toUpperCase()
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.info{
  padding: 0 30px;
}

.banner{
  border-radius: 8px;
  height: 200px;
  width: 100%;
  overflow: hidden;
  &.loading{
    background-color: $light-gray;
  }
  .title{
    z-index: 1;
  }
  .image{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .shadow{
    height: 100%;
    width: 100%;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.8) 0%, rgba(0,0,0,0) 70%);
  }
  .date{
    background-color: $black;
    padding: 16px;
    border-radius: 0 0 8px 0;
    .date-text{
      display: table-caption;
    }
  }
}
</style>
